// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { Typography } from '@kintent/glide';

import * as Styles from './RequestAccessSection.styles';
import CustomButton from '../../../../../components/CustomButton/CustomButton';
import { SERVICE_NOW_LOGIN_URL } from '../../../../../lib/constants';

function RequestAccessSection() {
  const handleRequestAccess = () => {
    window.open(SERVICE_NOW_LOGIN_URL, '_blank');
  };

  return (
    <Styles.Wrapper>
      <Typography
        as="h3"
        level="3"
      >
        Interested in learning more?
      </Typography>
      <Typography as="p">
        Request access and we can share more information about our trust and compliance program.
      </Typography>
      <CustomButton onClick={handleRequestAccess}>Request Access</CustomButton>
    </Styles.Wrapper>
  );
}

export default RequestAccessSection;
